import { useRef, useEffect } from "react";
import { usePlatformSettings } from "@/hooks/usePlatformSettings";
import { AlertTriangle } from "lucide-react";

const CSS_VAR = "--env-banner-height";

export default function EnvironmentBanner() {
  const { isSandbox, loading } = usePlatformSettings();
  const bannerRef = useRef<HTMLDivElement>(null);

  const visible = !loading && isSandbox;

  useEffect(() => {
    const el = bannerRef.current;
    if (!visible || !el) {
      document.documentElement.style.setProperty(CSS_VAR, "0px");
      return;
    }
    const update = () => {
      document.documentElement.style.setProperty(CSS_VAR, `${el.offsetHeight}px`);
    };
    const ro = new ResizeObserver(update);
    ro.observe(el);
    update();
    return () => {
      ro.disconnect();
      document.documentElement.style.setProperty(CSS_VAR, "0px");
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      ref={bannerRef}
      className="fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-2 bg-warning/15 border-b border-warning/30 px-4 py-1.5 text-xs font-medium text-warning backdrop-blur-sm"
    >
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
      <span>SANDBOX MODE — You are using test funds. No real transactions will be processed.</span>
    </div>
  );
}
